import React from 'react';
import { FileText, File, Image as ImageIcon } from 'lucide-react';
import { BASE_URL } from '../api/client';

interface DocumentThumbnailProps {
  fileName: string;
  filePath: string;
  mimeType: string;
  onClick?: () => void;
  size?: 'small' | 'medium' | 'large';
}

export const DocumentThumbnail: React.FC<DocumentThumbnailProps> = ({
  fileName,
  filePath,
  mimeType,
  onClick,
  size = 'medium'
}) => {
  const isImage = mimeType?.startsWith('image/');
  const isPdf = mimeType === 'application/pdf';

  const renderThumbnail = () => {
    if (isImage) {
      return (
        <img
          src={`${BASE_URL}/${filePath}`}
          alt={fileName}
          className="document-thumbnail-image"
          loading="lazy"
        />
      );
    }

    if (isPdf) {
      return (
        <div className="document-thumbnail-icon pdf">
          <FileText size={size === 'small' ? 32 : size === 'large' ? 56 : 40} />
          <span className="document-type-label">PDF</span>
        </div>
      );
    }

    return (
      <div className="document-thumbnail-icon generic">
        <File size={size === 'small' ? 32 : size === 'large' ? 56 : 40} />
        <span className="document-type-label">File</span>
      </div>
    );
  };

  return (
    <div
      className={`document-thumbnail ${size} ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyPress={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          onClick();
        }
      }}
    >
      {renderThumbnail()}
      {!isImage && (
        <div className="document-thumbnail-filename">
          {fileName.length > 25 ? `${fileName.substring(0, 22)}...` : fileName}
        </div>
      )}
    </div>
  );
};
